export default __webpack_public_path__ + "static/logo-normal-dc9a2b2d5e824963d30b11930e65ac6c.png";